<div class="info-card">
  @if (firstName) {
    <div class="info-card__item">
      <span class="info-card__label">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.firstname' | translate }}</span>
      <span class="info-card__value">{{ firstName }}</span>
    </div>
  }
  @if (lastName) {
    <div class="info-card__item">
      <span class="info-card__label">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.lastname' | translate }}</span>
      <span class="info-card__value">{{ lastName }}</span>
    </div>
  }
  @if (inss) {
    <div class="info-card__item">
      <span class="info-card__label">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.inss' | translate }}</span>
      <span class="info-card__value info-card__value--mono">{{ inss | inss }}</span>
    </div>
  }
  @if (nationality) {
    <div class="info-card__item">
      <span class="info-card__label">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.nationality' | translate }}</span>
      <span class="info-card__value">{{ nationality }}</span>
    </div>
  }
  @if (gender) {
    <div class="info-card__item">
      <span class="info-card__label">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.gender' | translate }}</span>
      <span class="info-card__value">{{ gender }}</span>
    </div>
  }
</div>
